<template>
  <div id="background">
    <div id="scan-container" class="container-fluid p-2">

      <div class="row scan-main-view">
        <mdb-container>
          <mdb-row>
            <mdb-col> </mdb-col>
            <mdb-col v-if="isAuthenticated">
              <span class="float-right">
                Station -  <i class="fas fa-map-marker-alt"> </i> <strong> {{ activeStationName() }}</strong>
              </span>
          </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col col="6">
               <input class="form-control" :class="isValidText" v-model="scanInput" ref="scanInput" @keyup.enter='onDecode' onblur="this.focus()" placeholder="Scan code"/>
            </mdb-col>
            <mdb-col col="6">
              <p class="time float-right">{{ time }}</p>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </div>

      <div class="row scan-history-view">

          <div v-show="showSpinner" class="spinner">
                <i class="fas fa-spinner fa-spin"></i>
          </div>

        <mdb-container v-show="!showSpinner">
          <h5>Recent Scans</h5>
          <hr />

          <mdb-row>
            <mdb-tbl striped class="wide">
              <mdb-tbl-head>
                <tr>
                  <th>Sync</th>
                  <th>Asset</th>
                  <th>Code</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Time</th>
                </tr>
              </mdb-tbl-head>

              <transition-group tag="tbody" name="fade">
                <tr
                  v-for="scan in scans.rows.slice(0, showLimit)"
                  :key="scan.key"
                >
                   <td v-show="syncSuccess(scan.sync_status)">
                     <span class="validation-success">
                       <i class='fas fa-check-circle' />
                     </span>
                   </td>

                   <td v-show="!syncSuccess(scan.sync_status)">
                      <span class="validation-failure">
                      <i class='fas fa-exclamation-circle'/>
                      </span>
                   </td>
                  <td>{{ scan.asset_type }}</td>
                  <td>{{ scan.code }}</td>
                  <td>{{ scan.location }}</td>
                  <td>{{ scan.scan_state }}</td>
                  <td>{{ scan.scan_time | formatDate }}</td>
                </tr>
              </transition-group>
            </mdb-tbl>
          </mdb-row>
        </mdb-container>
      </div>

      <mdb-container>
        <mdb-modal :show="!isAuthenticated" fullHeight position="top">
          <mdb-modal-body>
            <mdb-row center class="align-items-center">
              <p class="pr-2 mb-0">
                You are not logged in. Please login to proceed
              </p>
              <mdb-btn
                color="primary"
                @click="showLoginPopup = false"
                icon="user"
                ><a href="/sign-in">Ok, Log me In </a></mdb-btn
              >
            </mdb-row>
          </mdb-modal-body>
        </mdb-modal>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbModal,
  mdbContainer,
  mdbTbl,
  mdbTblHead,
} from "mdbvue";

import api from "@/api";
import { convertToLocalTime, formatToTimeZone } from "date-fns-timezone";
import { uuid } from "vue-uuid";

export default {
  name: "Landing",
  filters: {
    formatDate(date) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Vancouver";
      const localTime = formatToTimeZone(date, "MMM DD, hh:mm:ss a", {
        timeZone
      });
      return localTime;
    },
  },

  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbModal,
    mdbContainer,
    mdbTbl,
    mdbTblHead,
  },
  data() {
    return {
      camera: "off",
      isLoading: true,
      reload: false,
      scanResult: null,
      isValid: undefined,
      isValidText: "",
      scanInput: "",
      time: "",
      error: "",
      showLoginPopup: false,
      stationInfo: {},
      scannableKeys: [],
      scannableAssets: {},
      isStationSet: !!this.$store.state.stationInfo,
      stationState: '',
      scans: {
        rows: [],
      },
      showLimit: 10, // Number of recent scans to show on landing screen
    };
  },
  methods: {
    updateTime() {
      let current_time = new Date();
      this.time =
        this.zeroPadding(current_time.getHours()) +
        " : " +
        this.zeroPadding(current_time.getMinutes()) +
        " : " +
        this.zeroPadding(current_time.getSeconds());
    },
    zeroPadding(value) {
      return ("00" + value).slice(-2);
    },

    activeStationName() {
      return this.stationInfo ? this.stationInfo.scan_state.toUpperCase() : "UNDEFINED";
    },

    initApp() {
      if (this.$store.getters.isAuthenticated) {
        // this.turnCameraOn();
        this.setStationInfo();
        this.getRecentScans();
        this.getScannableAssets();
      }
    },

    getRecentScans() {
      api
        .getRecentScans()
        .then((response) => {
          response.data.length != 0
            ? this.scans.rows.push(...response.data)
            : null;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    setStationInfo() {
      this.stationInfo = this.$store.state.stationInfo;
    },

   getScannableAssets() {
     api.getScannableAssets().then((response) => {
       response.data.forEach((a) => {
         this.scannableKeys.push(a.scan_key);
         this.scannableAssets[`${a.scan_key}`] = { 'name': a.name, 'asset_type': a.asset_type }
       })
     })
    },

    syncSuccess(status) {
      return status === "success"
    },

    async onDecode() {
      let decodedString = this.scanInput;

      // Reset scan Input
      this.scanInput = '';
      try {
        this.scanResult = JSON.parse(decodedString);
        this.validScan() ? this.updateScanLocation() : this.isInvalidScan()
      } catch (e) {
        this.isValid = false;
        console.error("ERROR: Can't decode Image. Please try again..", e);
        this.shakeError();
        this.showError("Invalid scan. code not recognized");
        this.isValidText = "is-invalid";
         await this.timeout(500);
      }

        this.$refs.scanInput.focus();
    },

    validScan() {
      const scanKeys = Object.keys(this.scanResult);
      return scanKeys.length === 1
      && this.isScannable(scanKeys[0])
        ? true
        : false;
    },

    isScannable(scanKey) {
      const validRegex = /^[a-zA-Z0-9]+$/;
      return this.scannableKeys.includes(scanKey) && validRegex.test(this.scanCode())
    },

    isInvalidScan() {
      this.isValid = false;
      this.isValidText = "is-invalid";

      this.shakeError();
      this.showError("Invalid scan. code not recognized");
    },

    updateScanLocation() {
      this.isValid = true;
      this.isValidText = "is-valid";

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Vancouver";
      let now = convertToLocalTime(new Date(), {
        timeZone
      });
      let newScan = {
        code: this.scanCode(),
        asset_type: this.assetType(),
        scan_time: now,
        location: this.stationInfo.location,
        scan_state: this.stationInfo.scan_state,
        station_id: this.stationInfo.id,
        key: uuid.v4(),
      };

      //Asynchronously call API to update scan location
      this.pushScan(newScan);
    },

    async pushScan(newScan) {
      try {
        let response = await api.createScan(newScan);
        this.scans.rows.unshift(response.data);
        this.showSuccess();
      } catch (error) {
        this.errors = error.message;

        // Update sync_status to failed
        newScan.sync_status = "failed";
        this.$store.dispatch("updateFailedSync", newScan);

        // Update scans list
        this.scans.rows.unshift(newScan);
        this.showError()
      }
        this.$refs.scanInput.focus();
    },

    scanCode() {
      const keys = Object.keys(this.scanResult);
      return this.scanResult[keys[0]] //returns scan code e.g 2ba8
    },

    assetType() {
      const keys = Object.keys(this.scanResult);
      return this.scannableAssets[keys[0]]['asset_type']
    },

    resetValidationState() {
      this.isValid = undefined;
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },

     showSuccess() {
       return this.$toastr.success('scan is valid', 'Success', {timeOut: 2000, progressBar: true, positionClass: 'toast-bottom-full-width', preventDuplicates: true });
    },
    showError(message) {
      let error = message || "Failed";
      return this.$toastr.warning(error, 'Invalid scan', {timeOut: 2000, progressBar: true, positionClass: 'toast-bottom-full-width', preventDuplicates: true });
    },

    async refresh() {
      this.reload = true;
      await this.$nextTick();
      this.reload = false;
    },

    shakeError() {
      let containerDiv = document.querySelector("#scan-container");
      containerDiv.classList.remove('shake-error');

      setTimeout(function() {
        containerDiv.classList.add("shake-error");
      }, 100);
      setTimeout(function() {
        containerDiv.classList.remove("shake-error");
      }, 2000);
    },
  },

  computed: {
    validationPending() {
      return this.isValid === undefined && this.camera === "off";
    },

    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    showSpinner() {
      return this.isLoading;
    },
  },

  created() {
    this.initApp();
  },
  mounted() {
    setInterval(this.updateTime, 1000);
    setTimeout(() => (this.isLoading = false), 1000);
    setTimeout(() => this.setStationInfo(), 1000);
    setInterval(() => this.$refs.scanInput.focus(), 1000);
  },
};
</script>

<style>
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.shake-error {
  animation: shake 0.5s;
  animation-iteration-count: 3;
}

@keyframes starwipe {
  0% {
    clip-path: polygon(
      50% 20%,
      55% 35%,
      68% 35%,
      62% 52%,
      67% 70%,
      50% 60%,
      33% 70%,
      38% 52%,
      32% 35%,
      45% 35%
    );
  }
  100% {
    clip-path: polygon(
      50% 0%,
      63% 38%,
      100% 38%,
      69% 59%,
      82% 100%,
      50% 75%,
      18% 100%,
      31% 59%,
      0% 38%,
      37% 38%
    );
  }
}
</style>

<style scoped>
[v-cloak] {
  display: none !important;
}
.error {
  font-weight: bold;
  color: red;
}

.spinner {
  font-size: 7rem;
  margin: 0 auto;
}

#background {
  background-color: white;
  min-height: 100vh;
}

#scan-container {
  background-color: white;
  min-height: 100vh;
}

.time {
  text-align: center;
  letter-spacing: 0.05em;
  font-size: 20px;
}

.scan-main-view {
  /* min-height: 60vh; */
  padding: 0.5rem;
}
.scan-history-view {
  min-width: 100vw;
  /* max-height: 30vh; */
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}

.wide {
  width: 80vw;
}

.scan-history-view {
  padding-top: 2rem;
}

th {
  font-weight: bold;
}
</style>